<div>
  <h1 mat-dialog-title>Acknowledgment</h1>
  <img
    src="./assets/images/tcs-colour-digigov-blue.svg"
    class="img-fluid imageDisplay"
  />
  <mat-dialog-content>
    <h2 class="text-center">
      {{ deptName }}
    </h2>

    <div class="row justify-content-center mt-3 mb-0">
      <ngx-barcode
        [bc-value]="value"
        [bc-display-value]="true"
        [bc-width]="width"
        [bc-line-color]="lineColor"
        [bc-height]="height"
      ></ngx-barcode>
    </div>
    <div class="row m-0 p-0">
      <div class="col-6 p-0 m-0 font-weight-bold">Correspondance No.:</div>
      <div class="col-6 p-0 m-0">
        {{ corrNo }}
      </div>
    </div>

    <div class="row m-0 p-0">
      <div class="col-6 p-0 m-0 font-weight-bold">Correspondance Desc:</div>
      <div class="col-6 p-0 m-0">
        {{ corrDesc }}
      </div>
    </div>

    <div class="row m-0 p-0">
      <div class="col-6 p-0 m-0 font-weight-bold">Recieved Date:</div>
      <div class="col-6 p-0 m-0">
        {{ rDate }}
      </div>
    </div>

    <div class="row m-0 p-0">
      <div class="col-6 p-0 m-0 font-weight-bold">Letter Dated:</div>
      <div class="col-6 p-0 m-0">
        {{ lDate }}
      </div>
    </div>

    <div class="row m-0 p-0">
      <div class="col-6 p-0 m-0 font-weight-bold">Letter No:</div>
      <div class="col-6 p-0 m-0">
        {{ lNo }}
      </div>
    </div>

    <div class="row m-0 p-0">
      <div class="col-6 p-0 m-0 font-weight-bold">From:</div>
      <div class="col-6 p-0 m-0">
        {{ from }}
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="dg-button justify-content-end">
    <button mat-raised-button>Print</button>
    <button mat-raised-button [mat-dialog-close]="true">Close</button>
  </mat-dialog-actions>
</div>
<dg-org-search
  hidden
  [orgConfig]="orgConfig"
  [selectedOrgs]="selectedOrgs"
  (output)="getData3($event)"
></dg-org-search>
